module.exports = __webpack_public_path__ + "img/u1.7a79bbb3.png";